module.exports = __webpack_public_path__ + "static/media/HP_hero_LA.4e283fde.jpg";